import { defineComponent as _defineComponent } from 'vue'
import { unref as _unref, openBlock as _openBlock, createBlock as _createBlock, createCommentVNode as _createCommentVNode, toDisplayString as _toDisplayString, createElementVNode as _createElementVNode, createElementBlock as _createElementBlock, createVNode as _createVNode, normalizeClass as _normalizeClass, vModelText as _vModelText, withDirectives as _withDirectives, withModifiers as _withModifiers, Fragment as _Fragment, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

const _withScopeId = n => (_pushScopeId("data-v-7e134f27"),n=n(),_popScopeId(),n)
const _hoisted_1 = {
  key: 1,
  class: "d-flex justify-content-center mb-4"
}
const _hoisted_2 = { class: "text-center fw-bold mb-0 fs-5 pb-2" }
const _hoisted_3 = {
  key: 2,
  class: "d-flex justify-content-center mb-5"
}
const _hoisted_4 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { class: "spinner-border" }, null, -1))
const _hoisted_5 = [
  _hoisted_4
]
const _hoisted_6 = {
  id: "chatBoxContainer",
  class: "p-3 p-lg-4 shadow rounded-4 bg-white mb-4 mb-lg-5"
}
const _hoisted_7 = {
  class: /*#__PURE__*/_normalizeClass(['fw-bold fs-5 mb-3 lh-base cursor-pointer text-break']),
  "data-bs-toggle": "modal",
  "data-bs-target": "#chatModal"
}
const _hoisted_8 = { class: "d-flex flex-column flex-lg-row justify-content-between user-title" }
const _hoisted_9 = { class: "mb-2 d-flex align-items-center" }
const _hoisted_10 = {
  key: 0,
  class: "d-flex align-items-center"
}
const _hoisted_11 = {
  key: 0,
  class: "fs-7 fw-bold"
}
const _hoisted_12 = {
  key: 1,
  class: "fw-bold fs-7"
}
const _hoisted_13 = { key: 1 }
const _hoisted_14 = {
  key: 0,
  class: "last-comment position-relative w-100"
}
const _hoisted_15 = { key: 1 }
const _hoisted_16 = { class: "text-white bg-danger px-4 py-2 mb-2 text-nowrap" }
const _hoisted_17 = { key: 2 }
const _hoisted_18 = { class: "text-white bg-danger px-4 py-2 mb-2 text-nowrap" }
const _hoisted_19 = { key: 3 }
const _hoisted_20 = { class: "text-white bg-black px-4 py-2 mb-2 text-nowrap" }
const _hoisted_21 = { key: 4 }
const _hoisted_22 = { class: "bg-base-gray px-4 py-2 mb-2 text-nowrap" }
const _hoisted_23 = {
  key: 5,
  class: "text-danger fs-8 fw-bold text-center mb-2 text-nowrap"
}
const _hoisted_24 = {
  key: 0,
  class: "list-chat d-flex justify-content-center"
}
const _hoisted_25 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { class: "spinner-border" }, null, -1))
const _hoisted_26 = [
  _hoisted_25
]
const _hoisted_27 = ["onSubmit"]
const _hoisted_28 = { class: "me-lg-3 me-0 mb-4 mb-lg-0 w-100" }
const _hoisted_29 = ["placeholder", "rows"]
const _hoisted_30 = {
  key: 0,
  class: "invalid-error"
}
const _hoisted_31 = ["disabled"]
const _hoisted_32 = { class: "mb-2 d-flex justify-content-center" }

import { computed, ComputedRef, nextTick, onUnmounted, onMounted, ref, watch, watchEffect } from 'vue'
import Category from '@/components/category/index.vue'
import Button from '@/components/button/index.vue'
import UserAliasIcon from '@/components/user-alias-icon/index.vue'
import MessageItem from '../components/MessageItem.vue'
import Avatar from '@/components/avatar'
import { translate } from '@/languages/i18n'
import InputErrorMessage from '@/components/input-error-message/InputErrorMessage.vue'
import ChatModal from '@/views/user/conversations/components/ChatModal.vue'
import DeleteChatModal from '@/views/user/conversations/components/DeleteChatModal.vue'
import DeleteChatSuccessModal from '@/views/user/conversations/components/DeleteChatSuccessModal.vue'
import dayjs from 'dayjs'
import Breadcrumb from '@/components/breadcrumb/index.vue'
import chatService from '@/services/chat.services'

//validate
import useVuelidate from '@vuelidate/core'
import { required } from '@vuelidate/validators'
import { ReplayName } from '@/constants/common.ts'

//constant
import { DEFAULT_MIN_LENGTH } from '@/constants/number'
import { useStore } from 'vuex'
import { useRoute, useRouter, onBeforeRouteLeave } from 'vue-router'
import { CHAT_STORE, POST_STORE, ROOT_STORE } from '@/store/constants'
import { PostType } from '@/store/modules/post'
import { Chat } from '@/store/modules/chat'

import { useWebSocket } from '@/use/useWebsocket'

import VirtualList from 'vue3-virtual-scroll-list'
import { debounce } from 'lodash'
import commonService from '@/services/common.service'
import { customMaxLength, customMinLength } from '@/utils'
import LayoutAdmin from '@/components/layouts/layout-admin/index.vue'
import { usePath } from '@/use/usePath'
import { useChat } from '@/composables/chat'


export default /*#__PURE__*/_defineComponent({
  setup(__props) {

const store = useStore()
const route = useRoute()
const router = useRouter()
const virtual_list = ref()
const { path, id } = usePath()
const { connection, reconnect } = useWebSocket('chatChannel', {
  onConnected: () => {
    // Only re-fetch data if the page has finished initializing its initial data
    // Ensure the API is re-fetched in both cases: remaining on the tab and background reconnection
    if (getData.value) {
      fetchChatRoomData()
    }
  },
})

const { idComment, sendMessage, scrollMessage, addReconnectListeners, removeReconnectListeners, getData } = useChat()

const post = computed<ComputedRef<PostType>>(() => store.getters[POST_STORE.GETTERS.POST])
const page = computed(() => store.getters[CHAT_STORE.GETTERS.PAGE_CHAT])
const loadingChat = computed(() => store.getters[CHAT_STORE.GETTERS.LOADING_CHAT])

const chats = computed<ComputedRef<Array<Chat>>>(() => store.getters[CHAT_STORE.GETTERS.CHAT_ROOM])
const isMobile = computed<ComputedRef<boolean>>(() => store.getters[ROOT_STORE.GETTERS.CHECK_MOBILE_DEVICE])
const chatByAdmin = computed<ComputedRef<boolean>>(() => store.getters[CHAT_STORE.GETTERS.CHAT_BY_ADMIN])
const message = computed(() => store.getters[CHAT_STORE.GETTERS.GET_MESSAGE_SOCKET])
const breadcrumb = [
  {
    content: translate('CC10home'),
    to: `/community/communities/${route.params?.id}/dashboard`,
    active: false,
  },
  {
    content: translate('userManagement'),
    to: '',
    active: false,
  },
  {
    content: translate('chatManagement'),
    to: `/community/communities/${route.params?.id}/manage_chat_room?tab=recruitment`,
    active: false,
  },
  {
    content: translate('chat'),
    to: '',
    active: true,
  },
]
// const currentLoggedInUser = computed<ComputedRef<number>>(() => store.getters[COMMUNITY_STORE.GETTERS.GET_ME]?.community_management_id)
const updateMessageRead = async () => {
  try {
    const response = await chatService.updateMessageRead(route.params?.chatroom_id, { create_by_admin: route.path.includes('admin') })
  } catch (error) {
    console.log(error)
  }
}

const back = (): void => {
  if (route.meta?.layout === LayoutAdmin) {
    const previousUrlArray = router.options.history.state.back?.split('/')
    const checkPath = previousUrlArray?.pop()?.split('?')[0]
    if (['user_posts', 'operational_posts'].includes(checkPath)) {
      router.push(`/${path}/communities/${id}/manage_chat_room?tab=recruitment`)
      return
    }
    router.go(-1)
  } else {
    router.push(`/${path}/communities/${id}/chats`)
  }
}

const rules = computed(() => {
  return {
    content: {
      // required,
      maxLength: (value: string) => customMaxLength(value, 500),
      // minLength: (value: string) => customMinLength(value, DEFAULT_MIN_LENGTH),
    },
  }
})

const formData = ref({
  content: '',
})

const v$ = useVuelidate(rules, formData)

const onSubmit = async (): Promise<void> => {
  v$.value.$touch()

  isCheckedNGContent.value = false
  await checkNGContent()
  while (!isCheckedNGContent.value) {
    await new Promise((resolve) => setTimeout(resolve, 200))
  }

  if (v$.value.$invalid || ngKeyContent.value) return

  store.dispatch(CHAT_STORE.ACTIONS.SEND_MESSAGE, {
    chatroom_id: route.params?.chatroom_id,
    content: formData.value.content,
    params: {
      create_by_admin: route.path.includes('admin'),
    },
  })
  sendMessage.value = true
  updateMessageRead()
  v$.value.$reset()
  Object.assign(formData.value, {
    content: '',
  })
}
const loading = ref<boolean>(false)

onMounted(async () => {
  addReconnectListeners(connection, reconnect)
  if (route.params?.post_id) {
    loading.value = true
    idComment.value = route.query?.target_content_id

    await store.dispatch(POST_STORE.ACTIONS.GET_POST, {
      post_id: route.params.post_id,
      query: {
        chat_id: route.params?.chatroom_id,
        create_by_admin: route.path.includes('admin'),
      },
    })

    await fetchChatRoomData()

    getData.value = true
    setTimeout(() => {
      loading.value = false
    }, 500)
  }
})

watch(
  () => message.value,
  () => {
    if (message.value?.chatroom_id === route.params?.chatroom_id) {
      if (message.value?.type === 'create') {
        store.dispatch(CHAT_STORE.ACTIONS.RECEIVE_MESSAGE, message.value)
      }
      if (message.value?.type === 'delete') {
        store.dispatch(CHAT_STORE.ACTIONS.REMOVE_MESSAGE_WS, message.value.id)
      }
    }
  },
  {
    deep: true,
  }
)

watch(
  () => chats,
  async () => {
    await nextTick()
    await nextTick()
    const scroller = document.querySelector('.scroller') as HTMLElement
    if (page.value === 1) {
      // not use function scrollToBottom from virtual_list may cause infinite loop
      // await virtual_list.value?.scrollToBottom()
      virtual_list.value.scrollTop = 9999999999
      if (scroller) scrollMessage(scroller, 9999999999)
    } else {
      virtual_list.value.scrollTop = 8000
      if (scroller) scrollMessage(scroller, sendMessage.value ? 9999999999 : 8000)
    }
  },
  {
    deep: true,
  }
)

watchEffect(() => {
  if (getData.value && !post.value?.chatroom?.id && !chats.value?.length) {
    router.go(-2)
  }
})

const dataLoadMore = ref()

watchEffect(() => {
  dataLoadMore.value = [...chats.value]
  dataLoadMore.value.unshift({ id: 'first_chat_page' })
})

onMounted(() => {
  virtual_list.value = document.querySelector('.scroller')
  store.dispatch(CHAT_STORE.ACTIONS.SET_PAGE_CHAT, 1)
})

onBeforeRouteLeave(() => {
  getData.value = false
  store.dispatch(CHAT_STORE.ACTIONS.SET_PAGE_CHAT, 1)
})

const isCheckedNGContent = { value: false }
const ngKeyContent = ref<boolean>(false)
const checkNGContent = debounce(async () => {
  const data = await commonService.sendNGWordCheck({ sentence: v$.value.content.$model })
  ngKeyContent.value = data.data?.data?.has_ngword
  isCheckedNGContent.value = true
})

const setAvatar = (post: any) => {
  if (route.path.includes('admin')) return post?.user_post?.avatar_url
  else {
    if (post?.chatroom?.partner_avatar_url) return post?.chatroom?.partner_avatar_url
    return false
  }
}
// 2022/10/17 VietNC profile image UAT#4622(Ph2-R20221021)
const is30Day = (post: any) => {
  if (route.path.includes('admin')) {
    return post?.user_post?.is_deleted_in_30_days
  } else {
    return post?.chatroom?.is_deleted_in_30_days
  }
}

const fetchChatRoomData = async () => {
  if (route.params?.chatroom_id) {
    await store.dispatch(CHAT_STORE.ACTIONS.GET_CHAT_ROOM, {
      chatroom_id: route.params?.chatroom_id,
      params: {
        create_by_admin: route.path.includes('admin'),
        page: 1,
        change: true,
        target_content_id: route.query?.target_content_id,
      },
    })
  }
}

onUnmounted(() => {
  removeReconnectListeners()
})

return (_ctx: any,_cache: any) => {
  return (_openBlock(), _createElementBlock(_Fragment, null, [
    (_unref(route).path.includes('admin'))
      ? (_openBlock(), _createBlock(Breadcrumb, {
          key: 0,
          breadcrumb: breadcrumb,
          class: "mx-0"
        }))
      : _createCommentVNode("", true),
    (!_unref(route).path.includes('admin'))
      ? (_openBlock(), _createElementBlock("div", _hoisted_1, [
          _createElementVNode("h1", _hoisted_2, _toDisplayString(_unref(translate)('chat')), 1)
        ]))
      : _createCommentVNode("", true),
    (loading.value)
      ? (_openBlock(), _createElementBlock("div", _hoisted_3, _hoisted_5))
      : _createCommentVNode("", true),
    _createElementVNode("div", {
      class: _normalizeClass([loading.value && 'hidden-layout'])
    }, [
      _createElementVNode("div", _hoisted_6, [
        _createElementVNode("div", {
          class: _normalizeClass(['detail-header position-relative', _unref(isMobile) ? 'pb-2' : 'border-bottom mb-4 pb-4 '])
        }, [
          _createVNode(Category, {
            content_type: _unref(post)?.content_type
          }, null, 8, ["content_type"]),
          _createElementVNode("h3", _hoisted_7, _toDisplayString(_unref(post)?.title), 1),
          _createElementVNode("div", _hoisted_8, [
            _createElementVNode("div", _hoisted_9, [
              _createVNode(_unref(Avatar), {
                is_deleted_in_30_days: is30Day(_unref(post)),
                user_image_url: setAvatar(_unref(post)),
                size: 'small',
                userType: _unref(route).path.includes('admin') ? _unref(post)?.user_post?.user_type : _unref(post)?.chatroom?.partner_user_type
              }, null, 8, ["is_deleted_in_30_days", "user_image_url", "userType"]),
              (_unref(route).path.includes('admin'))
                ? (_openBlock(), _createElementBlock("div", _hoisted_10, [
                    _createVNode(UserAliasIcon, {
                      userType: _unref(post)?.user_post?.user_type
                    }, null, 8, ["userType"]),
                    (_unref(post)?.user_post?.user_type !== 'community_admin')
                      ? (_openBlock(), _createElementBlock("span", _hoisted_11, _toDisplayString(_unref(post)?.user_post?.management_no +
                  ' ' +
                  _unref(ReplayName)(
                    _unref(post)?.user_post?.is_deleted_in_30_days,
                    _unref(post)?.user_post?.available,
                    _unref(post)?.user_post?.family_name,
                    _unref(post)?.user_post?.given_name,
                    _unref(post)?.user_post?.user_type
                  )) + " " + _toDisplayString(_unref(post)?.user_post?.user_type == 'alumni' && [0, 1].includes(_unref(post)?.user_post?.is_deleted_in_30_days) ? `（ ${_unref(post)?.user_post?.display_name} ）` : ''), 1))
                      : (_openBlock(), _createElementBlock("span", _hoisted_12, _toDisplayString(_unref(post)?.user_post?.display_name), 1))
                  ]))
                : (_openBlock(), _createElementBlock("div", _hoisted_13, [
                    _createVNode(UserAliasIcon, {
                      title: _unref(post)?.chatroom?.partner_display_name,
                      userType: _unref(post)?.chatroom?.partner_user_type
                    }, null, 8, ["title", "userType"])
                  ]))
            ]),
            _createElementVNode("div", {
              class: _normalizeClass(['d-flex', !_unref(isMobile) ? 'flex-column align-items-lg-center align-items-end' : ''])
            }, [
              (_unref(isMobile))
                ? (_openBlock(), _createElementBlock("div", _hoisted_14))
                : _createCommentVNode("", true),
              (_unref(post)?.chatroom.is_deleted_in_30_days !== 0 && _unref(post)?.chatroom?.partner_user_type !== 'community_admin')
                ? (_openBlock(), _createElementBlock("div", _hoisted_15, [
                    _createElementVNode("span", _hoisted_16, _toDisplayString(_unref(translate)('SM10withdrawn')), 1)
                  ]))
                : (!_unref(post)?.chatroom.available && _unref(post)?.chatroom?.partner_user_type !== 'community_admin')
                  ? (_openBlock(), _createElementBlock("div", _hoisted_17, [
                      _createElementVNode("span", _hoisted_18, _toDisplayString(_unref(translate)('SM10stopped')), 1)
                    ]))
                  : (_unref(post)?.chatroom?.closed)
                    ? (_openBlock(), _createElementBlock("div", _hoisted_19, [
                        _createElementVNode("span", _hoisted_20, _toDisplayString(_unref(translate)('end')), 1)
                      ]))
                    : (_unref(post)?.published == false)
                      ? (_openBlock(), _createElementBlock("div", _hoisted_21, [
                          _createElementVNode("span", _hoisted_22, _toDisplayString(_unref(translate)('private')), 1)
                        ]))
                      : true
                        ? (_openBlock(), _createElementBlock("div", _hoisted_23, _toDisplayString(_unref(dayjs)(_unref(post)?.chatroom.end_date, 'YYYY-MM-DD').format('MM/DD')) + "まで会話できます ", 1))
                        : _createCommentVNode("", true)
            ], 2)
          ])
        ], 2),
        (_unref(loadingChat))
          ? (_openBlock(), _createElementBlock("div", _hoisted_24, _hoisted_26))
          : _createCommentVNode("", true),
        _createVNode(_unref(VirtualList), {
          class: "scroller",
          ref: (_value, _refs) => {
            _refs['virtual_list'] = _value
            virtual_list.value = _value
          },
          style: {"height":"540px","overflow-y":"auto","overflow-x":"hidden"},
          "estimate-size": 80,
          keeps: 1000,
          start: 15,
          "data-key": 'id',
          "data-sources": dataLoadMore.value,
          "data-component": MessageItem,
          "extra-props": { is_admin: _unref(route).path.includes('/admin'), post: _unref(post), id_comment: _unref(idComment) }
        }, null, 8, ["data-sources", "extra-props"]),
        (_unref(post)?.chatroom?.can_chat && _unref(post)?.published)
          ? (_openBlock(), _createElementBlock("form", {
              key: 1,
              onSubmit: _withModifiers(onSubmit, ["prevent"]),
              action: "",
              class: "bg-gray p-3 d-flex form-chat"
            }, [
              _createElementVNode("div", _hoisted_28, [
                _withDirectives(_createElementVNode("textarea", {
                  placeholder: _unref(translate)('placeholder'),
                  name: "content",
                  class: _normalizeClass(['form-control ', ngKeyContent.value || _unref(v$).content.$error ? 'is-invalid' : '', _unref(isMobile) ? 'p-1' : 'p-2']),
                  rows: _unref(isMobile) ? 1 : 2,
                  "onUpdate:modelValue": _cache[0] || (_cache[0] = ($event: any) => ((_unref(v$).content.$model) = $event)),
                  onBlur: _cache[1] || (_cache[1] = () => (_unref(v$).content.$model = _unref(v$).content.$model.replace(/\n+$/, ''))),
                  onChange: _cache[2] || (_cache[2] = 
//@ts-ignore
(...args) => (_unref(checkNGContent) && _unref(checkNGContent)(...args))),
                  onClick: updateMessageRead
                }, null, 42, _hoisted_29), [
                  [_vModelText, _unref(v$).content.$model]
                ]),
                (ngKeyContent.value && !_unref(v$).content.$error)
                  ? (_openBlock(), _createElementBlock("div", _hoisted_30, _toDisplayString(_unref(translate)('ngKeyWord')), 1))
                  : _createCommentVNode("", true),
                _createVNode(InputErrorMessage, {
                  title: _unref(translate)('chatContent'),
                  params: [_unref(DEFAULT_MIN_LENGTH), 500],
                  validator: _unref(v$).content.$errors[0]?.$validator
                }, null, 8, ["title", "params", "validator"])
              ]),
              (!_unref(isMobile))
                ? (_openBlock(), _createBlock(Button, {
                    key: 0,
                    title: _unref(translate)('SO65send'),
                    type: 'secondary',
                    htmlType: 'submit',
                    class: "fw-bold mt-2",
                    disabled: !formData.value.content.trim()
                  }, null, 8, ["title", "disabled"]))
                : _createCommentVNode("", true),
              (_unref(isMobile))
                ? (_openBlock(), _createElementBlock("button", {
                    key: 1,
                    class: _normalizeClass(['button-mobile', ngKeyContent.value || _unref(v$).content.$error || !formData.value.content.trim() ? '' : 'button-submit']),
                    htmlType: 'submit',
                    disabled: _unref(v$).content.$error || !formData.value.content.trim()
                  }, _toDisplayString(_unref(translate)('SO65send')), 11, _hoisted_31))
                : _createCommentVNode("", true)
            ], 40, _hoisted_27))
          : _createCommentVNode("", true)
      ]),
      _createElementVNode("div", _hoisted_32, [
        _createVNode(Button, {
          title: _unref(translate)('SM65backChatList'),
          type: 'secondary',
          className: "mb-0 mb-lg-3 fw-bold",
          onClick: back
        }, null, 8, ["title"])
      ]),
      _createVNode(ChatModal, {
        create_by_admin: _unref(route).path.includes('admin')
      }, null, 8, ["create_by_admin"]),
      _createVNode(DeleteChatModal),
      _createVNode(DeleteChatSuccessModal)
    ], 2)
  ], 64))
}
}

})